module.exports = __webpack_public_path__ + "img/star-map_backgrounds-white_circle.a886462.webp";